<template>
    <div>
    <b-card
        header-tag="header"
        footer-tag="footer">
        <div slot="header">
          <i class="fa fa-list-ul" aria-hidden="true"></i>
            API-Key Form
          <div class="card-header-actions">
            <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
              <small class="text-muted">docs</small>
            </a>
          </div>
        </div>
        <div>
          <b-row>
            <b-col sm="12">
              <alert-success :show="successMessage != ''"> {{ successMessage }} </alert-success>
              <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>
              <!-- App -->
              <b-form-group>
                <label for="sendTo">App</label>
                <v-select class="select-condition" v-model="form.appName"  :options="appOptions"></v-select>
              </b-form-group>
              <!-- Secret -->
              <b-form-group>
                <label for="sendTo">Secret</label>
                <b-form-input v-model="form.secret" placeholder="Enter secret"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div slot="footer">
          <b-button :disabled="!isActive" @click="createApiKey" class="mr-2" type="button" size="sm" variant="primary">
            <i class="fa fa-dot-circle-o"></i>
            Save
          </b-button>
          <b-button :disabled="!isActive" v-b-modal.confirmDelete v-if="$route.params.id" type="button" size="sm" variant="danger">
            <i class="fa fa-ban"></i>
            Delete
          </b-button>
          <alert-confirm
            :id="'confirmDelete'"
            @confirm="deleteApiKey">
            confirm to delete ?
          </alert-confirm>
        </div>
    </b-card>
    </div>
</template>
<script>
import AlertSuccess from '@/components/alert/AlertSuccess';
import AlertConfirm from '@/components/alert/AlertConfirm';
import ApiKeyForm from '@/models/apikeyform.js';
import { OptionList } from '../../models/option-list';
import vSelect from 'vue-select';

export default {
  data () {
    return {
      form: {},
      errorMessage: '',
      successMessage: '',
      fieldErrors: {},
      alertConfirm: false,
      isActive: true,
      optionList: new OptionList(this.axios),
      appOptions: []
    };
  },
  created () {
    document.title = 'Admin Console: Messaging Generate Api Key';
  },
  methods: {
    createApiKey () {
      const apiKeyForm = new ApiKeyForm({ appName: this.form.appName.label, secret: this.form.secret });
      console.log(apiKeyForm);
      const apiKeyFD = new FormData();
      for (let key in apiKeyForm) {
        if (apiKeyForm[key]) {
          apiKeyFD.append(key, apiKeyForm[key]);
        }
      }
      this.axios({
        method: 'post',
        url: (`${process.env.VUE_APP_URL_MESSAGING_API}/api-key/genarate`),
        data: apiKeyFD
      }).then(res => {
        const respData = res.data;
        if ('Success' === respData.message) {
          this.saveDone = true;
          this.$router.push({ name: 'messaging-api-key' });
        }
      })
        .catch(error => {
          this.isError = true;
          console.log('Error :', error.response);
          this.errorMessage = error.response.data.data.map(value => value.msg).join(', ');
        });
    },
    getApiKeyForEdit () {
      const id = this.$route.params.id;
      if (id) {
        this.isActive = false;
        this.axios.get(process.env.VUE_APP_URL_MESSAGING_API + '/api-key')
          .then(response => {
            this.isActive = true;
            const data = response.data.data;
            if (!data) {
              throw new Error('data not found');
            }
            this.form = {
              app: data.app,
              secret: data.secret,
              apiKey: data.apiKey
            };
          })
          .catch(error => {
            this.errorHandler(error);
          });
      }
    },
    deleteApiKey () {
    },
    errorHandler (error) {
      this.errorMessage = error.message;
      if (error.response) {
        this.errorMessage = error.response.data.message;
        const data = error.response.data.data;
        this.setFieldErrors(data);
      }
    },
    successHandler () {
      this.successMessage = 'success';
    },
    setFieldErrors (fields) {
      if (fields) {
        for (const field of fields) {
          this.fieldErrors[field.param] = { message: field.msg, isCorrect: false };
        }
      }
    }
  },
  components: {
    AlertSuccess,
    AlertConfirm,
    'v-select': vSelect
  },
  mounted () {
    this.optionList.loadAppOptions()
      .then(response => {
        this.appOptions = response;
      })
      .catch(error => console.log(error));
  }
};
</script>
